/**
 * Shimmer skeleton placeholder — used while content loads.
 */

interface SkeletonCardProps {
  count?: number;
}

export function SkeletonCard() {
  return (
    <div
      className="rounded-2xl overflow-hidden mb-3 animate-pulse"
      style={{ background: "var(--tg-secondary-bg)" }}
    >
      {/* image placeholder */}
      <div className="w-full h-40" style={{ background: "var(--surface-muted)" }} />
      <div className="p-4 space-y-2">
        <div className="h-4 rounded" style={{ background: "var(--surface-muted)", width: "75%" }} />
        <div className="h-3 rounded" style={{ background: "var(--surface-muted)", width: "40%" }} />
      </div>
    </div>
  );
}

export default function Skeleton({ count = 4 }: SkeletonCardProps) {
  return (
    <div className="p-4">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
